import * as React from "react";
const SvgFiRrFlyingDisc = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flying-disc_svg__a)">
      <path
        fill="#062147"
        d="M21.952 2.048C20.666.761 18.912.08 16.877.016c-.039-.005-1.839.056-2.764.257-3.057.661-6.175 2.458-8.778 5.062-5.487 5.488-6.962 12.942-3.287 16.617 1.352 1.352 3.213 2.051 5.381 2.051.782 0 1.605-.091 2.458-.276 3.057-.661 6.175-2.458 8.778-5.062 5.487-5.488 6.962-12.942 3.287-16.617M6.749 6.749c2.336-2.335 5.101-3.941 7.787-4.522a9.6 9.6 0 0 1 1.954-.225c.204.122.395.259.559.423.975.975 1.212 2.629.669 4.659-.595 2.222-2.035 4.559-4.055 6.579-3.964 3.964-9.108 5.514-11.239 3.385a2.8 2.8 0 0 1-.433-.579c.023-2.996 1.705-6.666 4.758-9.72m10.502 10.502c-2.336 2.335-5.101 3.941-7.787 4.522-2.529.545-4.66.107-6.002-1.235a4.7 4.7 0 0 1-.721-.962c.72.283 1.516.43 2.373.43 3.043 0 6.776-1.743 9.963-4.93 2.265-2.264 3.889-4.919 4.572-7.476.496-1.851.454-3.508-.075-4.857.351.202.68.433.964.717 2.895 2.896 1.42 9.081-3.287 13.789z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flying-disc_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlyingDisc;
